import packageJSON from '../../package.json';
import { Icons } from '../components/Icon/Icon';

const CREDIT_CURRENCY = packageJSON?.creditCurrency ?? 'Credits';

const TypesService = {
	BlockchainsById: {
		0: { Name: '', Icon: 'GAS_PUMP_RIM', name: '', symbol: 'GAS_PUMP_RIM', network: '' },
		1: { Name: 'Bitcoin', Icon: 'BTC', name: 'Bitcoin', symbol: 'BTC', network: 'Bitcoin' },
		2: { Name: 'Tron', Icon: 'TRX', name: 'Tron', symbol: 'TRX', network: 'Tron' },
		3: { Name: 'Ethereum', Icon: 'ETH', name: 'Ethereum', symbol: 'ETH', network: 'Ethereum' },
		4: { Name: 'TON', Icon: 'TON', name: 'TON', symbol: 'TON', network: 'TON' },
		5: { Name: 'Litecoin', Icon: 'LTC', name: 'Litecoin', symbol: 'LTC', network: 'Litecoin' },
		6: { Name: 'BNB Smart Chain', Icon: 'BNB', name: 'BNB', symbol: 'BNB', network: 'BSC' },
	},
	CurrenciesById: {
		1: {
			Name: 'BTC',
			BlockchainId: 1,
			Company: 'Bitcoin',
			Standart: '',
			CompanyIcon: 'BTC',
			Color: '#F7931A',
			FeeType: 'front_configurating',
			Precision: 8,
			Pattern: /^(tb1|bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/,
			ScanLink: 'https://www.blockchain.com/ru/btc/tx/',
		},
		2: {
			Name: 'TRX',
			BlockchainId: 2,
			Company: 'Tron',
			Standart: '',
			CompanyIcon: 'TRX',
			Color: '#E23D33',
			FeeType: 'back_calculating',
			Precision: 6,
			Pattern: /T[A-Za-z1-9]{33}$/,
			ScanLink: 'https://tronscan.org/#/transaction/',
		},
		3: {
			Name: 'USDT',
			BlockchainId: 2,
			Company: 'Tether',
			Standart: 'TRC-20',
			CompanyIcon: 'USDT',
			Color: '#26A17B',
			FeeType: 'method_selecting',
			Precision: 2,
			Pattern: /T[A-Za-z1-9]{33}$/,
			ScanLink: 'https://tronscan.org/#/transaction/',
		},
		4: {
			Name: 'ETH',
			BlockchainId: 3,
			Company: 'Ethereum',
			Standart: '',
			CompanyIcon: 'ETH',
			Color: '#627EEA',
			FeeType: 'back_calculating',
			Precision: 6,
			Pattern: /^0x[a-fA-F0-9]{40}$/,
			ScanLink: 'https://etherscan.io/tx/',
		},
		5: {
			Name: 'USDT',
			BlockchainId: 3,
			Company: 'Tether',
			Standart: 'ERC-20',
			CompanyIcon: 'USDT',
			Color: '#26A17B',
			FeeType: 'back_calculating',
			Precision: 2,
			Pattern: /^0x[a-fA-F0-9]{40}$/,
			ScanLink: 'https://etherscan.io/tx/',
		},
		8: {
			Name: 'Credits',
			BlockchainId: 0,
			Company: '',
			Standart: '',
			CompanyIcon: CREDIT_CURRENCY,
			Color: '#0455A3',
			FeeType: '',
			Precision: 2,
			Pattern: null,
			ScanLink: 'https://www.blockchain.com/ru/btc/tx/',
		},
		9: {
			Name: 'USDC',
			BlockchainId: 3,
			Company: 'Circle & Coinbase',
			Standart: 'ERC-20',
			CompanyIcon: 'USDC',
			Color: '#3E73C4',
			FeeType: 'back_calculating',
			Precision: 2,
			Pattern: /^0x[a-fA-F0-9]{40}$/,
			ScanLink: 'https://etherscan.io/tx/',
		},
		10: {
			Name: 'LTC',
			BlockchainId: 5,
			Company: 'Litecoin',
			Standart: '',
			CompanyIcon: 'LTC',
			Color: '#345D9D',
			FeeType: 'front_configurating',
			Precision: 8,
			Pattern: /^([LM3][a-km-zA-HJ-NP-Z1-9]{25,34}|(ltc1|tltc1)[02-9ac-hj-np-z]{39,59})$/,
			ScanLink: 'https://litecoinspace.org/tx/',
		},
		11: {
			Name: 'BNB',
			BlockchainId: 6,
			Company: 'Smart Chain',
			Standart: '',
			CompanyIcon: 'BNB',
			Color: '#F3BA2F',
			FeeType: 'back_calculating',
			Precision: 6,
			Pattern: /^0x[a-fA-F0-9]{40}$/,
			ScanLink: 'https://bscscan.com/tx/',
		},
		12: {
			Name: 'USDT',
			BlockchainId: 6,
			Company: 'Tether USD',
			Standart: 'BEP-20',
			CompanyIcon: 'USDT',
			Color: '#26A17B',
			FeeType: 'back_calculating',
			Precision: 2,
			Pattern: /^0x[a-fA-F0-9]{40}$/,
			ScanLink: 'https://bscscan.com/tx/',
		},
		13: {
			Name: 'USDC',
			BlockchainId: 6,
			Company: 'Circle & Coinbase',
			Standart: 'BEP-20',
			CompanyIcon: 'USDC',
			Color: '#3E73C4',
			FeeType: 'back_calculating',
			Precision: 2,
			Pattern: /^0x[a-fA-F0-9]{40}$/,
			ScanLink: 'https://bscscan.com/tx/',
		},
	},
	FiatPrecision: 2,

	symbolsNeedCorrectBlockchain: {
		ETH: {
			Symbol: 'ETH',
			blockchains: [
				{ Label: 'Ethereum', Name: 'Ethereum', Icon: 'ETH', symbol: 'ETH' },
				{ Label: 'Binance Smart Chain', Name: 'BSC', Icon: 'BNB', symbol: 'BNB' },
			],
		},
	},

	NetworkByCurrency: {
		'USDT-TRC20': 'Tron',
		'USDT-ERC20': 'Ethereum',
		'USDT-BEP20': 'BNB Smart Chain',
		'USDC-ERC20': 'Ethereum',
		'USDC-BEP20': 'BNB Smart Chain',
		TRX: 'Tron',
		ETH: 'Ethereum',
		BTC: 'BTC',
	},
	SmallIconsBySymbol: {
		'USDT-TRC20': Icons.SMALL_USDT_TRC20_COIN,
		'USDT-ERC20': Icons.USDT_ERC20_COIN,

		TRX: Icons.SMALL_TRX_COIN,
		ETH: Icons.ETH_COIN,
		BTC: Icons.BTC_COIN,
	},
	IconsBySymbol: {
		'USDT-TRC20': Icons.USDT_TRC20_COIN,
		'USDT-ERC20': Icons.USDT_ERC20_COIN,
		TRX: Icons.TRX_COIN,
		ETH: Icons.ETH_COIN,
		BTC: Icons.BTC_COIN,
	},
	IconsByName: {
		'Tether USD (Tron)': Icons.USDT_TRC20_COIN,
		'Tether USD (Ethereum)': Icons.USDT_ERC20_COIN,
		Tronix: Icons.TRX_COIN,
		Ether: Icons.ETH_COIN,
		Bitcoin: Icons.BTC_COIN,
	},
	PinCodeLength: 6,
	DigitsCodeLength: 6,
	TransactionDirectionByType: {
		1: 'Received',
		2: 'Sent',
		3: 'Received',
		4: 'Sent',
		5: 'Sent',
		6: 'Sent',
		7: 'Received',
		8: 'Sent',
		9: 'Sent',
		10: 'Sent',
	},

	riskSignalsParam: {
		merchant_services: {
			title: 'Merchant Services',
			color: 'green',
		},
		exchange_licensed: { title: 'Licensed exchange', color: 'green' },
		exchange_unlicensed: { title: 'Unlicensed exchange', color: 'orange' },
		p2p_exchange_licensed: { title: 'P2P Licensed exchange', color: 'green' },
		p2p_exchange_unlicensed: { title: 'P2P Unlicensed exchange', color: 'orange' },
		ico: {
			title: 'ICO',
			color: 'green',
		},
		exchange: {
			title: 'Exchange',
			color: 'green',
		},
		trusted_exchange: {
			title: 'Exchange | Trusted',
			color: 'green',
		},
		wallet: {
			title: 'Wallet',
			color: 'green',
		},
		miner: {
			title: 'Miner',
			color: 'green',
		},
		payment: {
			title: 'Payment Processor',
			color: 'green',
		},
		marketplace: {
			title: 'Marketplace',
			color: 'green',
		},
		exchange_mlrisk_low: {
			title: 'Exchange | Low Risk',
			color: 'green',
		},
		p2p_exchange_mlrisk_low: {
			title: 'P2P Exchange | Low Risk',
			color: 'green',
		},
		p2p_exchange: {
			title: 'P2P Exchange',
			color: 'green',
		},
		seized_assets: {
			title: 'Seized Assets',
			color: 'green',
		},
		other: {
			title: 'Other',
			color: 'green',
		},
		bridge: {
			title: 'Bridge',
			color: 'green',
		},
		nft_platform_collection: {
			title: 'NFT Platform Collection',
			color: 'green',
		},

		infrastructure_as_a_service: {
			title: 'Infrastructure Service',
			color: 'orange',
		},
		decentralized_exchange_contract: {
			title: 'Exchange | Decentralized contract',
			color: 'orange',
		},
		smart_contract: {
			title: 'Smart Contract',
			color: 'orange',
		},
		token_smart_contract: {
			title: 'Token Smart Contract',
			color: 'orange',
		},
		lending_contract: {
			title: 'Lending Contract',
			color: 'orange',
		},
		protocol_privacy: {
			title: 'Protocol Privacy',
			color: 'orange',
		},
		unnamed_service: {
			title: 'Unnamed Service',
			color: 'orange',
		},
		atm: {
			title: 'ATM',
			color: 'orange',
		},
		risky_exchange: {
			title: 'Exchange | Risky',
			color: 'orange',
		},
		exchange_mlrisk_moderate: {
			title: 'Exchange | Moderate Risk',
			color: 'orange',
		},
		exchange_mlrisk_high: {
			title: 'Exchange | High Risk',
			color: 'orange',
		},
		exchange_mlrisk_veryhigh: {
			title: 'Exchange | Very High Risk',
			color: 'orange',
		},
		p2p_exchange_mlrisk_high: {
			title: 'P2P Exchange | High Risk',
			color: 'orange',
		},
		liquidity_pools: {
			title: 'Liquidity Pools',
			color: 'orange',
		},

		fraud_shop: {
			title: 'Fraud Shop',
			color: 'red',
		},
		illicit_actor_org: {
			title: 'Illicit Organization',
			color: 'red',
		},
		high_risk_jurisdiction: {
			title: 'High Risk Jurisdiction',
			color: 'red',
		},
		enforcement_action: {
			title: 'Enforcement action',
			color: 'red',
		},
		ransom: {
			title: 'Ransom',
			color: 'red',
		},
		dark_market: {
			title: 'Dark Market',
			color: 'red',
		},
		dark_service: {
			title: 'Dark Service',
			color: 'red',
		},
		illegal_service: {
			title: 'Illegal Service',
			color: 'red',
		},
		mixer: {
			title: 'Mixer',
			color: 'red',
		},
		scam: {
			title: 'Scam',
			color: 'red',
		},
		gambling: {
			title: 'Gambling',
			color: 'red',
		},
		stolen_coins: {
			title: 'Stolen Coins',
			color: 'red',
		},
		exchange_fraudulent: {
			title: 'Fraudulent Exchange',
			color: 'red',
		},
		child_exploitation: {
			title: 'Child Exploitation',
			color: 'red',
		},
		sanctions: {
			title: 'Sanctions',
			color: 'red',
		},
		terrorism_financing: {
			title: 'Terrorism Financing',
			color: 'red',
		},
		special_measures: {
			title: 'Special Measures',
			color: 'red',
		},
		online_pharmacy: {
			title: 'Online Pharmacy',
			color: 'red',
		},
		malware: {
			title: 'Malware',
			color: 'red',
		},
		settled: {
			title: 'Settled',
			color: 'violet',
		},
		unnamed: {
			title: 'Uncategorized',
			color: 'blue',
		},
	},

	TransactionStatusesById: {
		0: { label: null },
		1: { label: 'In queue', condition: 'waiting' },
		2: { label: 'Completed' },
		3: { label: 'Failed', condition: 'failed' },
		4: { label: 'In progress', condition: 'waiting' },
		5: { label: 'Confirming', condition: 'waiting' },
		6: { label: 'Canceled', condition: 'failed' },
		7: { label: 'Canceled' },
		8: { label: 'Waiting for GS Deposit' },
		9: { label: 'Waiting for Energy' },
		10: { label: 'Declined' },
	},
	BackButtonExceptions: ['/', '/all-wallets', '/main-page'],
	DesktopPlatforms: ['tdesktop', 'web', 'macos'],
	MobilePlatforms: ['android', 'ios', 'weba'],
	CardColors: {
		transparent: {
			backgroundGradients: ['rgba(255, 255, 255, 0.1)', 'rgba(255, 255, 255, 0.1)'],
			border: 'rgba(255, 255, 255, 0.2)',
			textColor: '#fff',
		},
		black: { backgroundGradients: ['#16171B', '#31363A'] },
		white: { backgroundGradients: ['#EAEAEA', '#FFF'], textColor: '#21242D' },
		purple: { backgroundGradients: ['#5719DD', '#5946FB'] },
		blue: { backgroundGradients: ['#004CEF', '#00ABEF'] },
		green: { backgroundGradients: ['#267EA1', '#26A17B'] },
	},

	TransactionCategoryById: {
		1: { title: 'Products', icon: Icons.BASKET_FILL },
		2: { title: 'Taxi', icon: Icons.CAR_FILL },
		3: { title: 'Cafe', icon: Icons.FORK_FILL },
	},
	getTransactionCategoryId(categoryId) {
		return (
			this.TransactionCategoryById[categoryId] || {
				title: '',
				icon: null,
			}
		);
	},

	TransactionDestinationIsons: {
		products: 'BASKET_FILL',
		food: 'FORK_FILL',
		transport: 'CAR_FILL',
	},
};

export default TypesService;
